import { useState, useEffect } from 'react';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';
import { NoRecordFound, PageLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { getClaimTimelineApi, getShopVisitStatusTimelineApi } from '../apiServices';
import { checkApiStatus } from '../../../utils';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../utils/mixpanel';
import { ShowAttachments } from '../../../shared_elements/components';
import { AttachFile } from '@mui/icons-material';

const TimelineModal = ({ timeLineData, toggleModalFn, slug, pageTitle, params }) => {
    const { enqueueSnackbar } = useSnackbar()
    const headerArr = pageTitle === "Claim"
        ? ["Status From", "Status To", "Raised By", "Created At", "Remarks", "Attachments"]
        : ["Status From", "Status To", "Raised By", "Created At", "Comments", "Attachments"]
    const [isLoading, setLoading] = useState({ pageLoader: false });
    const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
    const [timeLine, setTimeLine] = useState([]);
    const [attachments, setAttachments] = useState({ modal: false, data: null })
    const getTimeLineHistory = async () => {
        toggleLoader("pageLoader", true)
        const response = await globalGetService(pageTitle === "Claim" ? getClaimTimelineApi(params, slug) : getShopVisitStatusTimelineApi(slug))
        if (checkApiStatus(response)) {
            toggleLoader("pageLoader", false)
            setTimeLine(response?.data?.data)
        } else {
            toggleLoader("pageLoader", false)
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
        }
    }
    useEffect(() => {
        getTimeLineHistory()
    }, [])
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Status TimeLine`, page_type: page_type, })
    }
    return (
        <>
            {isLoading?.pageLoader ? <PageLoader /> :
                <Dialog
                    open={timeLineData?.modal}
                    aria-labelledby="scroll-dialog-title"
                    className='add-lease-dialog'
                    fullWidth
                    maxWidth="md"
                    // PaperProps={pageTitle === "Claim" ? { sx: { height: "600px" } } : undefined}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="scroll-dialog-title">Status Timeline </DialogTitle>
                    <DialogContent dividers={true} sx={pageTitle === "Claim" ? { p: 2, height: "100%", display: "flex", flexDirection: "column" } : { p: 2 }}>
                        <TableContainer style={{ maxHeight: pageTitle === "Claim" ? undefined : (!isLoading?.pageLoader && timeLine?.length === 0 ? "auto" : `${window.innerHeight - 480}px`), overflow: "auto", }} component={Paper} className="scrollable-table scrollable-table-container">
                            <Table size="small" className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {headerArr.map((header, idx) => (
                                            <TableCell key={idx} className={'nowrap-cell range-header'}>
                                                <b>{header}</b>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {timeLine?.length > 0 && timeLine?.map((row, index) => {
                                        return (
                                            <>
                                                <TableRow key={index}>
                                                    <TableCell> {row?.payout_status_from?.label || row?.status_from?.label || "--"} </TableCell>
                                                    <TableCell> {row?.payout_status_to?.label || row?.status_to?.label || "--"} </TableCell>
                                                    <TableCell >{row?.changed_by?.name ?? "--"}</TableCell>
                                                    <TableCell  > {row?.created_at && moment(row.created_at).isValid() ? moment(row.created_at).format('MMM DD, YYYY') : "--"}</TableCell>
                                                    {pageTitle === "Claim" ? (
                                                        <>
                                                            <TableCell>{row?.round_remarks ?? "--"}</TableCell>
                                                            <TableCell>{
                                                                row?.attachments?.length > 0 ? (
                                                                    <Tooltip title="Attached File(s)">
                                                                        <Box sx={{ display: "flex", gap: '2px' }}>
                                                                            <AttachFile fontSize="small" color="primary" onClick={() => { setAttachments({ modal: true, data: row }); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                                            <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                                                                                ({row.attachments.length})
                                                                            </Box>
                                                                        </Box>
                                                                    </Tooltip>
                                                                ) : "--"
                                                            }</TableCell>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <TableCell >{row?.comment ?? "--"}</TableCell>
                                                            <TableCell >{
                                                                row?.attachments?.length > 0 && (
                                                                    <Tooltip title="Attached File(s)">
                                                                        <Box sx={{ display: "flex", gap: '2px' }}>
                                                                            <AttachFile fontSize="small" color="primary" onClick={() => { setAttachments({ modal: true, data: row }); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                                            <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                                                                                ({row.attachments.length})
                                                                            </Box>
                                                                        </Box>
                                                                    </Tooltip>
                                                                )
                                                            }</TableCell>
                                                        </>
                                                    )}
                                                </TableRow>
                                                {pageTitle === "Claim" && row?.group?.length > 0 && (
                                                    <TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={headerArr.length}>
                                                            <Box sx={{ margin: 1 }}>
                                                                <Table size="small">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            {["User", "Status", "Performed At", "Comments", "Attachments"].map((header, idx) => (
                                                                                <TableCell key={idx} className={'nowrap-cell range-header'}>
                                                                                    <b>{header}</b>
                                                                                </TableCell>
                                                                            ))}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {row.group.map((detail, detailIdx) => (
                                                                            <TableRow key={detailIdx}>
                                                                                <TableCell>{detail?.user?.name ?? "--"}</TableCell>
                                                                                <TableCell>{detail?.status?.label ?? "--"}</TableCell>
                                                                                <TableCell>{detail?.performed_at && moment(detail.performed_at).isValid() ? moment(detail.performed_at).format('MMM DD, YYYY') : "--"}</TableCell>
                                                                                <TableCell>{detail?.comment ?? "--"}</TableCell>
                                                                                <TableCell>{
                                                                                    detail?.attachments?.length > 0 ? (
                                                                                        <Tooltip title="Attached File(s)">
                                                                                            <Box sx={{ display: "flex", gap: '2px' }}>
                                                                                                <AttachFile fontSize="small" color="primary" onClick={() => { setAttachments({ modal: true, data: detail }); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                                                                <Box sx={{ position: "relative", bottom: 8, right: '3px', fontSize: '12px', color: 'text.secondary', whiteSpace: 'nowrap', }} >
                                                                                                    ({detail.attachments.length})
                                                                                                </Box>
                                                                                            </Box>
                                                                                        </Tooltip>
                                                                                    ) : "--"
                                                                                }</TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </>)
                                    }
                                    )
                                        }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {attachments.modal ? <ShowAttachments
                            moduleName="Status Timeline"
                            attachmentsData={attachments}
                            toggleModalFn={() => setAttachments({ modal: false, data: null })}
                            onViewDisabled={true}
                            permissionKey='shop_visit'
                        /> : null}
                        {!isLoading?.pageLoader && timeLine?.length === 0 && <NoRecordFound/>}
                    </DialogContent>
                    <DialogActions>
                        <Box style={{ float: 'right' }}>
                            <Button className='cancel-btn' onClick={() => { toggleModalFn(); handleItemClicked('Close Button') }} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Close</Button>
                        </Box>
                    </DialogActions>
                </Dialog>}
        </>
    )
}
export default TimelineModal